export default function ({ store, from, to }) {
  if (
    Object.keys(from.meta).includes('middleware') &&
    from.meta.middleware.includes('leave-page')
  ) {
    // store.dispatch('layouts/newToast', {
    //   variant: 'warning',
    //   message: '你即將再 3 秒後離開此頁面，填寫內容不會儲存',
    //   speed: 'normal'
    // })
  }
  return false
}
